import * as React from 'react';
import Select, { SelectValue } from '../../../../Components/Base/Select/Select';
import {
	CaseTypeType,
	useLazyWorkplaceRootCaseTypesQuery,
	useLazyWorkplacesQuery,
} from '../../../../graphql/graphql';
import { FieldError } from 'react-hook-form';
import { useState } from 'react';
import Loading from '../../../../Components/Loading';
import useTranslation from '../../../../Hooks/useTranslation';
import { useEffectAsync } from '../../../../helpers';

interface Props {
	onChange?: (value: SelectValue) => void;
	value?: SelectValue;
	error?: FieldError;
}

const RootCaseTypeSelect: React.FC<Props> = props => {
	const { value, onChange } = props;
	const [isLoading, setIsLoading] = useState(false);
	const [options, setOptions] = useState<SelectValue[]>([]);
	const { t } = useTranslation();
	const [getWorkplaces] = useLazyWorkplacesQuery();
	const [getWorkplaceRootCaseTypes] = useLazyWorkplaceRootCaseTypesQuery();

	useEffectAsync(async () => {
		setIsLoading(true);

		const items: SelectValue[] = [];

		//LOADING ALL WORKPLACES THAT USER HAVE ACCESS TO
		const workplacesData = await getWorkplaces();
		const workplaceIds = workplacesData?.data?.workplaces?.data?.map(
			item => item!.id,
		);

		//LOADING ALL CASE TYPES FOR ALL ACCESS-ABLE WORKPLACES
		const workplaceCaseTypesData = await getWorkplaceRootCaseTypes({
			workplaceIds: workplaceIds,
			caseTypeTypes: [CaseTypeType.CaseType, CaseTypeType.Folder],
		});

		//GOT THROUGH ALL CASE TYPES AND ADD THEM INTRO FIELD IF THERE IS NO ANY WITH SAME CODE
		workplaceCaseTypesData?.data?.workplaceCaseTypes?.data?.forEach(
			caseType => {
				if (!items.some(item => item.value === caseType?.caseType?.code)) {
					if (caseType?.caseType?.code && caseType?.caseType?.label) {
						items.push({
							value: caseType.caseType.code,
							label: caseType.caseType.label,
						});
					}
				}
			},
		);

		setOptions(items);
		setIsLoading(false);
	}, []);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<Select
			options={options}
			{...props}
			onChange={onChange}
			value={value}
			placeholder={t('base.shared.pick')}
		/>
	);
};

export default RootCaseTypeSelect;
